export default "__VITE_PUBLIC_ASSET__435d05e7__"